module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || '3xlzfqkt',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
